import React from 'react'
import { Button } from '@chakra-ui/react'

export function PrimaryButton({ children, ...props }) {
    return (
        <Button isFullWidth type="button" {...props}>
            {children}
        </Button>
    )
}